<template>
  <div>
    <Nav :authenticated="authFlag" />
    <header class="hero">
      <div class="container-fluid d-none">
        <div class="row">
          <div
            style="padding: 0;"
            :class="!auth.authenticated ? 'col-md-8' : 'col-md-12'"
            class="hero__map"
          >
            <Map
              :coordinates="coordinates"
              :styles="mapStyles"
              :infoWindows="infoWindows"
              :markers="null"
              :height="!auth.authenticated ? '514px' : '360px'"
              type="roadmap"
            />
          </div>
          <div class="col-md-4 hero__login" v-if="!auth.authenticated">
            <div class="container text-white">
              <div class="mb-5">
                <h2 class="title">Create an account</h2>
                <small
                  class="text-light d-block"
                >Create an Infodemics account to begin.</small>
              </div>

              <div class="buttons-group mb-3">
                <button @click="auth.auth0login()" class="btn btn-dark btn-social btn-facebook">
                  <ion-icon name="logo-facebook"></ion-icon>Sign Up with Facebook
                </button>
                <button @click="auth.auth0login()" class="btn btn-dark btn-social btn-google">
                  <ion-icon name="logo-google"></ion-icon>Sign Up with Google
                </button>
                <button
                  type="button"
                  class="btn btn-social btn-light"
                  data-toggle="modal"
                  data-target="#signupModal"
                >
                  <ion-icon name="ios-call"></ion-icon>Sign Up with Phone
                </button>
              </div>

              <p class="d-block text-light mb-2">
                Already have an account?
                <a
                  href="#loginModal"
                  data-toggle="modal"
                  data-target="#loginModal"
                  class="text-white"
                >
                  <b>Login</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row hero__content">
          <div class="col-12 col-md-6">
            <h1 class="mt-0 mb-2">COVID19<sup>†</sup></h1>
            <p>Infodemics, a risk communication platform, is helping with the effort.</p>
            <p class="d-flex flex-row flex-wrap">
              <a href="/covid19tracker" class="btn btn-primary btn-lg d-inline mr-2 mb-2">COVID19</a>
              <a href="/blog" class="btn btn-outline-light btn-lg d-inline mr-2 mb-2">Our Blog</a>
            </p>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <section class="highlights bg-light py-0">
      <div class="container-fluid">
        <div class="row no-gutter">
          <div class="col-12 col-md-5 highlights__image">
            <div></div>
          </div>
          <div class="col-12 col-md-7 highlights__items">
            <div class="row">
              <div class="col-12 mb-5">
                <h3>Communicating Health Risk to the Last Mile</h3>
              </div>
              <div class="col-12 col-md-6">
                <img src="./icons/location.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Define Your Location</h6>
                <p>Epidemics are best managed from a geographical context.</p>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/circles.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Work With Circles</h6>
                <p>Various teams work in concert to stem outbreaks. Use our circles to manage government health agencies, community groups and more.</p>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/communication.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Communicate Risk</h6>
                <p>Use our inbuilt mediums to communicate health risks. SMS, Interactive Voice Response (IVR), USSD shortcodes, eMail and similar channels are easy to use.</p>
              </div>

              <div class="col-12 col-md-6">
                <img src="./icons/partner.svg" height="50" alt="Location" />
                <h6 class="text-uppercase mt-4">Planning and Intervention</h6>
                <p>Reach out to us to manage volunteers, coordinate with communities with accurate feedback and have an all in one communication solution.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="partners" style="background:#fff">
      <div class="container">
        <div class="row text-center">
          <div class="col-12 mb-4">
            <h2 class="text-capitalize">Our Partners</h2>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-5 mb-md-0">
            <img src="./images/giz.png" alt="GIZ" />
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-5 mb-md-0">
            <img src="./images/ncdc.png" alt="NCDC" />
          </div>
          <!--div class="col-12 col-sm-6 col-md-3 mb-5 mb-md-0">
            <img src="./images/grid3.png" alt="GRID3" />
          </div-->
          <div class="col-12 col-sm-6 col-md-4" style="margin-top:-10px">
            <img src="./images/ecowas.png" alt="ECOWAS" />
          </div>
        </div>
      </div>
    </section>

    <section class="cta py-0">
      <div class="container">
        <div class="row cta__content justify-content-center text-center">
          <div class="col-12 my-5 py-5">
            <h2 class="text-capitalize mb-4">Try Infodemics for Free</h2>
            <a href data-toggle="modal"
              data-target="#signupModal" class="btn btn-primary btn-lg d-inline">Get Started</a>
          </div>
        </div>
      </div>
    </section>

    <LoginModal :auth="auth" />
    <InviteModal :auth="auth" />
    <ResetModal :auth="auth" />
    <SignupModal :auth="auth" />
    <Footer />
  </div>
</template>

<script>
  const mapStyles = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#2F71FF"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2f2f2"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#D4E0FA"
        }
      ]
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f7f7f7"
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#dedede"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ff7070"
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        }
      ]
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#e0e0e0"
        },
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#e0e0e0"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#46bcec"
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ededed"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [
        {
          hue: "#ff0000"
        },
        {
          saturation: "-100"
        }
      ]
    }
  ];
  // @ is an alias to /src
  import Nav from "@/components/Landing/Nav/Nav.vue";
  import Map from "@/components/Map/Map.vue";
  import LoginModal from "@/components/Auth/LoginModal/LoginModal.vue";
  import InviteModal from "@/components/Auth/InviteModal/InviteModal.vue";
  import ResetModal from "@/components/Auth/ResetModal/ResetModal.vue";
  import SignupModal from "@/components/Auth/SignupModal/SignupModal.vue";
  import Footer from "@/components/Landing/Footer/Footer.vue";

  export default {
    name: "landing",
    props: ["auth", "authenticated"],
    data() {
      return {
        authFlag: this.$props.authenticated,
        coordinates: { lat: 9.0748812, lng: 7.465183 },
        infoWindows: [{
          options: {
            content: `<div>
              <h6 style='margin: 7px auto 3px auto;font-size: 14px;'>
                <img style='margin-right: 2px;height: 100%;max-height: 24px;' 
                src="${require('../../assets/infodemics-logo-icon.svg')}" alt /> Nigeria</h6>
            </div>`
          },
          text: "Nigeria",
          position: { lat: 9.0748812, lng: 7.465183 },
          open: true,
          canClose: false
        }],
        markers: [{
          position: { lat: 9.0748812, lng: 7.465183 },
          info: {
            content: `<div>
              <h6 style='margin: 7px auto 3px auto;font-size: 14px;'>
                <img style='margin-right: 2px;height: 100%;max-height: 24px;' 
                src="${require('../../assets/infodemics-logo-icon.svg')}" alt /> Nigeria</h6>
            </div>`,
            open: false
          }
        }],
        mapStyles: mapStyles
      };
    },
    components: {
      Nav,
      Map,
      LoginModal,
      InviteModal,
      ResetModal,
      SignupModal,
      Footer
    },
    created() {
      if (!(localStorage.getItem('ustk') && localStorage.getItem('udt'))) {
        this.authFlag = false;
      }
    },
  }
</script>

<style scoped lang="scss" src="./Landing.scss"></style>
